import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

//import { Modal } from "antd";

export function RouterPrompt(props) {
    const { when, onOK, onCancel, title, okText, cancelText, message } = props;

    const history = useHistory();

    const [showPrompt, setShowPrompt] = useState(false);
    const [currentPath, setCurrentPath] = useState("");

    useEffect(() => {
        if (when) {
            history.block((prompt) => {
                if (history.location.pathname !== prompt.pathname) {
                    setCurrentPath({ pathname: prompt.pathname, state: prompt.state });
                    setShowPrompt(true);
                    return "true";
                } else if (prompt.pathname === '/') {
                    return "false"
                } else {
                    return "false";
                }
            });
        } else {
            history.block(() => { });
        }

        return () => {
            history.block(() => { });
        };
    }, [history, when]);

    const handleOK = useCallback(async () => {
        if (onOK) {
            const canRoute = await Promise.resolve(onOK());
            if (canRoute) {
                history.block(() => { });
                history.push(currentPath);
            }
        }
    }, [currentPath, history, onOK]);

    const handleCancel = useCallback(async () => {
        if (onCancel) {
            const canRoute = await Promise.resolve(onCancel());
            if (canRoute) {
                history.block(() => { });
                history.push(currentPath);
            }
        }
        setShowPrompt(false);
    }, [currentPath, history, onCancel]);

    return showPrompt ? (
        <Dialog
            open={showPrompt}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>{cancelText}</Button>
                <Button onClick={handleOK} autoFocus>
                    {okText}
                </Button>
            </DialogActions>
        </Dialog>

        // <Modal
        //     title={title}
        //     visible={showPrompt}
        //     onOk={handleOK}
        //     okText={okText}
        //     onCancel={handleCancel}
        //     cancelText={cancelText}
        //     closable={true}
        // >
        // There are unsaved changes. Are you sure want to leave this page ?
        // </Modal>
    ) : null;
}

RouterPrompt.defaultProps = {
    message: 'There are unsaved changes. Are you sure want to leave this page ?'
}
